import App from './App.svelte';

// main entry point
const app = new App({
	target: document.body
});

export default app;